
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qwikcvhgregsaxtinvra.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF3aWtjdmhncmVnc2F4dGludnJhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2MDg2MzcsImV4cCI6MjA1NjE4NDYzN30.6p_HjvT12bxlIxvHoZ-Q-boTS5ppqoNlmbRa58zplZM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});
